import { useTranslation } from "react-i18next";

const popularProducts = [
  {
    name: "Nike Dunk Low",
    price: "od 89 zł",
    image: "https://readdy.ai/api/search-image?query=Editorial%20product%20shot%20of%20Nike%20Dunk%20Low%20sneakers%20in%20vintage%20green%20and%20white%20colorway%20on%20raw%20concrete%20surface%2C%20dramatic%20side%20lighting%20from%20left%20creating%20strong%20shadows%2C%20urban%20streetwear%20photography%20aesthetic%2C%20hints%20of%20weathered%20metal%20and%20rust%20textures%20in%20defocused%20background%2C%20industrial%20warehouse%20setting%2C%20high%20contrast%20fashion%20editorial%2C%20sharp%20detail%20on%20leather%20grain%20and%20sole%20texture&width=400&height=500&seq=prod-01-v2&orientation=portrait",
  },
  {
    name: "Essentials Hoodie",
    price: "od 129 zł",
    image: "https://readdy.ai/api/search-image?query=Lifestyle%20photography%20of%20a%20dark%20charcoal%20Fear%20of%20God%20Essentials%20hoodie%20hanging%20casually%20on%20a%20coat%20rack%20against%20warm%20white%20textured%20wall%2C%20gentle%20afternoon%20sunlight%20creating%20soft%20shadows%2C%20minimalist%20bedroom%20interior%20with%20dried%20pampas%20grass%20and%20ceramic%20vase%2C%20cozy%20atmospheric%20mood%2C%20editorial%20catalog%20style%20with%20relaxed%20sophistication%2C%20fine%20knit%20texture%20clearly%20visible&width=400&height=500&seq=prod-02-v2&orientation=portrait",
  },
  {
    name: "Stussy T-Shirt",
    price: "od 59 zł",
    image: "https://readdy.ai/api/search-image?query=Flat%20lay%20product%20photography%20of%20a%20vintage%20washed%20black%20Stussy%20graphic%20t-shirt%20on%20light%20washed%20denim%20surface%2C%20top%20down%20view%20with%20natural%20window%20light%2C%2090s%20skate%20culture%20aesthetic%20with%20film%20camera%20and%20retro%20sunglasses%20nearby%2C%20warm%20nostalgic%20tones%20with%20slight%20fade%20effect%2C%20streetwear%20brand%20editorial%2C%20detailed%20screen%20print%20texture%20visible%2C%20cool%20relaxed%20summer%20vibe&width=400&height=500&seq=prod-03-v2&orientation=portrait",
  },
  {
    name: "Arc'teryx Jacket",
    price: "od 249 zł",
    image: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20product%20photography%20of%20a%20bright%20coral%20orange%20Arcteryx%20shell%20jacket%20on%20moss%20covered%20rock%20in%20misty%20forest%20setting%2C%20soft%20diffuse%20light%20through%20fog%20and%20pine%20trees%2C%20contrasting%20vibrant%20technical%20fabric%20against%20muted%20natural%20greens%20and%20greys%2C%20Pacific%20Northwest%20wilderness%20aesthetic%2C%20professional%20gear%20catalog%2C%20water%20droplets%20visible%20on%20DWR%20fabric%20surface%2C%20adventure%20lifestyle%20mood&width=400&height=500&seq=prod-04-v2&orientation=portrait",
  },
  {
    name: "New Balance 550",
    price: "od 199 zł",
    image: "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20cream%20white%20and%20navy%20New%20Balance%20550%20retro%20basketball%20sneakers%20on%20polished%20maple%20wood%20basketball%20court%20floor%2C%20warm%20arena%20lighting%20from%20overhead%2C%20nostalgic%201980s%20sports%20aesthetic%20with%20vintage%20gym%20equipment%20out%20of%20focus%20in%20background%2C%20classic%20sneaker%20catalog%20style%2C%20sharp%20detail%20on%20perforated%20leather%20and%20suede%20overlays%2C%20athletic%20heritage%20mood&width=400&height=500&seq=prod-05-v2&orientation=portrait",
  },
  {
    name: "Carhartt Beanie",
    price: "od 39 zł",
    image: "https://readdy.ai/api/search-image?query=Intimate%20close%20up%20product%20shot%20of%20a%20burnt%20orange%20ribbed%20knit%20Carhartt%20beanie%20on%20weathered%20wooden%20workbench%20surface%2C%20warm%20tungsten%20workshop%20lighting%20from%20above%2C%20rugged%20authentic%20workwear%20aesthetic%20with%20leather%20work%20gloves%20and%20vintage%20tools%20softly%20blurred%20around%20edges%2C%20artisan%20craft%20atmosphere%2C%20detailed%20cable%20knit%20pattern%20texture%20clearly%20visible%2C%20honest%20heritage%20brand%20feel&width=400&height=500&seq=prod-06-v2&orientation=portrait",
  },
];

export default function ProductScroll() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-950">
              {t("products.title")}
            </h2>
          </div>
          <p className="text-foreground-500 text-sm">
            {t("products.subtitle")}
          </p>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
          {popularProducts.map((product) => (
            <div
              key={product.name}
              className="flex-shrink-0 w-[220px] md:w-[260px] group cursor-pointer"
            >
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/5] mb-3">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-foreground-950/70 text-white text-xs font-medium whitespace-nowrap">
                  {product.price}
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                  <p className="text-white font-semibold text-sm">{product.name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}